/**
 * Axios config for cross-origin calls to timeshifter-api-legacy (TIM-309).
 * Forwards the ts_anon_id cookie so server-side funnel events can read anonymousId.
 */
export const legacyJetlagApiConfig = { withCredentials: true };
